define('ProductBlockView',['jquery', 'backbone', 'app', 'SubView', 'InternalLinkView', 'LazyLoad', 'TagCommander',
        'views/blocks/ProductBoostModalView',
        'template!blocks/quantity', 'template!blocks/product-block'],
    function ($, Backbone, app, SubView, InternalLinkView, LazyLoad, TagCommander,
              ProductBoostModalView,
              templateQuantity, templateProductBlock)
{

    var ProductView = Backbone.View.extend(SubView).extend({
        events: {
            'click a': 'trackClick',
            'click .btn-add': 'addProduct',
            'click .btn-preorder': 'preorder',
            'click .btn-like':'activateBtnLike',
            'mouseenter':'onHover',
            'mouseleave':'onHover'
        },
        initialize: function (options)
        {
            var view = this,
                cart = view.cart = options.cart ? options.cart : app.getCart();
            view.subviews = [];
            view.id_product = view.$el.data('id_product').toString();
            view.el.productblock = true;
            if(!view.$el.is('.inactive')){
                // si le produit n'est pas inactif
                view.setup();
            }else{
                view.lazyLoad();
                view.listenToOnce(cart,'changeContext deliveryUpdate',view.setup);
            }

            var devaticsStrategyId = view.$el.data('devatics-strategy');
            if(devaticsStrategyId){
                view.setupDevatics(devaticsStrategyId);
            }

        },
        setup:function(){
            //
            // le setup n'est executé que sur les blocs produit actifs
            //
            var view = this,
                cart = view.cart;

            if(view.isSetup) return;

            view.initLike();
            InternalLinkView.initializeLinksOfView(view);

            view.lazyLoad();
            view.$('figure img').one('load',function(){
               view.$el.addClass('loaded');
            });

            view.stopListening();
            view.listenTo(cart,'changeContext deliveryUpdate',view.onCartChangeContext);
            view.listenTo(app,'updateDocumentDimensions scroll',view.lazyLoad);
            view.listenTo(cart,'productsChange',view.onProductsChange);

            view.isSetup = true;
        },

        setupDevatics:function(){
            // ajoute les attributs HTML pour devatics
            var view = this,
                $block = view.$el,
                id_product= view.id_product,
                product = app.getProduct(id_product),
                currencyIsoCode = app.getCurrency().getIsoCode();
            //
            $block.attr('data-product',id_product);
            $block.find('a.picture,a.product-title').attr('data-product-link',id_product);
            $block.find('.btn-add').attr({
                'data-add-to-basket':'',
                'data-product-id':id_product,
                'data-unit-price':product.getPrice('ttc',true,app.getCart()),
                'data-currency':currencyIsoCode
            },id_product);
        },

        onProductsChange:function(){
            var view = this,
                id_product= view.id_product,
                product = app.getProduct(id_product);
            view.$('.product-block__quantity').attr('data-qty',product.getCartQuantity());
        },

        initLike: function ()
        {
            // affiche le bouton "favoris"
            var view = this,
                isLiked = app.getCustomer().isProductLiked(view.id_product),
                btn = view.$('.btn-like');
            btn.toggleClass('active',isLiked);
        },

        trackClick: function (e){
            TagCommander.tc_ev_gl(e.currentTarget,'product_click',{product:app.getProduct(this.id_product)});
        },

        lazyLoad:function(){
            var view = this,
                lazyNotLoaded = view.$('.picture .lazyload:not(.ready)');
            if(lazyNotLoaded.length == 0){
                view.stopListening(app,'updateDocumentDimensions scroll',view.lazyLoad);
            }
            LazyLoad(lazyNotLoaded,true);
        },

        activateBtnLike: function (e) {
            var currentTarget = e.currentTarget,
                view = this,
                btn = $(currentTarget),
                customer = app.getCustomer(),
                isActive;

            if (customer.isLogged()){ // test si connecter
                customer.likeProduct(view.id_product);
                // TODO translations
                isActive = btn.hasClass('active')
                btn.toggleClass('active',!isActive);
                app.notify('bottom',app.t((isActive?'Unlike':'Like')+' success !','Product'));
                TagCommander.eventGA(currentTarget,"Fiche Produit","Ajout aux produits préférés",view.id_product,{
                    click_value:isActive?'Remove':'Add',
                })
            }else{
                app.alert({title: t('Attention','UI'), subtitle: t('Vous devez vous connecter pour ajouter ce produit à vos favoris','Product')})
            }

        },
        addProduct: function (e)
        {
            var view = this,
                loader = $(e.currentTarget).find('.circle-loader'),
                product = app.getProduct(view.id_product);

            function addProduct(){
                TagCommander.tc_ev_gl(e.currentTarget,'product_add',{product:product});
                loader.addClass('playing')
                view.cart.addProduct(product.id).done(function(){
                    view.trigger('addProduct',product);
                    loader.removeClass('playing');
                });
            }

            if(product.isMenu()){
                view.trackClick(e);
                app.go('product',{product:product});
            }else if(product.requireProductBoost()){
                var productBoostView = new ProductBoostModalView(product.getProductBoost(),false);
                view.listenTo(productBoostView,'cancel',addProduct);
                app.displayModal(productBoostView);
            }else{
                addProduct();
            }
        },
        onCartChangeContext:function(){
            var view = this,
                product = app.getProduct(view.id_product),
                cart = view.cart,
                visible = product && product.isVisibleInContext(false,cart),
                buyable = product && product.isBuyableInContext(cart);
            view.$el
                .toggleClass('inactive',!visible)
                .toggleClass('active',visible)
                .toggleClass('buyable',buyable)
                .toggleClass('not-buyable',!buyable);
            if(visible){
                view.setup();
            }
        },

        preorder:function(){
            app.getCart().preorder(this.id_product);
        },

        onHover:function(e){
            this.$el.toggleClass('hover',e.type=='mouseenter');
        }
    });

    ProductView.initializeProductBlocksOfView = function (view)
    {
        return ProductView.initializeProductBlocksOfEl(view.$el);
    };
    ProductView.initializeProductBlocksOfEl = function ($el)
    {
        var views = [];
        $el.find('.product-block').each(function ()
        {
            if(this.productblock) return;
            views.push(new ProductView({el: this}));
        });
        return views;
    };

    return ProductView;
});
